// Righe di una tabella alte da 1 a 5 linee di testo, tutte quanto la più
// alta (regole in assets/css/_tables.scss):
// - le celle che sforano le 5 linee si accorciano (data-clamp), con il testo
//   intero nel title; quelle che non si possono accorciare (campi, bottoni)
//   lasciano la loro riga fuori dal calcolo;
// - --row-height porta tutte le altre righe all'altezza della più alta;
// - da 4 bottoni in su la colonna delle azioni va su due righe, con lo stesso
//   numero di colonne in tutta la tabella (data-action-cols).
// Si usa sulle b-table (tables/template.vue) e sulle tabelle scritte a mano
// (foglio di quadratura), che si segnano con data-rows per avere le stesse
// regole.
// Righe di servizio e totali: restano della loro altezza.
const SKIP =
  ".b-table-details, .b-table-empty-row, .b-table-busy-slot, .b-table-top-row, .b-table-bottom-row, .totals";

/**
 * @param {HTMLTableElement[]} tables
 */
export const calibrateRows = (tables) => {
  // Azzerare l'altezza accorcia per un attimo la tabella e il browser
  // riporterebbe in alto lo scorrimento: si conserva.
  const scrollers = tables.map((table) => [
    table.parentElement,
    table.parentElement?.scrollTop,
  ]);
  const all = tables.map((table) => {
    const rows = [...table.querySelectorAll(":scope > tbody > tr")].filter(
      (row) => !row.matches(SKIP),
    );
    table.style.removeProperty("--row-height");
    for (const row of rows) {
      for (const td of row.cells) {
        if (td.dataset.clamp !== undefined) {
          delete td.dataset.clamp;
          td.removeAttribute("title");
        }
      }
    }
    // Colonne della griglia delle azioni uguali in tutte le righe, prese
    // dalla riga con più bottoni (alcuni compaiono solo in certe righe):
    // da 4 in su metà dei bottoni per riga (_tables.scss).
    const buttons = Math.max(
      0,
      ...rows.map(
        (row) =>
          [
            ...(row.querySelector(":scope > td.actions .action-buttons")
              ?.children || []),
          ].filter((el) => getComputedStyle(el).display !== "none").length,
      ),
    );
    if (buttons >= 4) {
      table.dataset.actionCols = Math.ceil(buttons / 2);
      table.style.setProperty("--action-cols", table.dataset.actionCols);
    } else {
      delete table.dataset.actionCols;
      table.style.removeProperty("--action-cols");
    }
    return { table, rows };
  });
  const clamps = [];
  for (const item of all) {
    item.tall = new Set();
    for (const row of item.rows) {
      for (const td of row.cells) {
        if (td.classList.contains("actions")) continue;
        const el = td.firstElementChild;
        const range = document.createRange();
        range.selectNodeContents(td);
        const style = getComputedStyle(el || td);
        const lines =
          range.getBoundingClientRect().height /
          parseFloat(style.lineHeight);
        if (!(lines > 5.5)) continue;
        const clampable =
          el &&
          td.children.length === 1 &&
          [...td.childNodes].every(
            (n) => n === el || !n.textContent.trim(),
          ) &&
          ["SPAN", "DIV", "P"].includes(el.tagName) &&
          ["inline", "block"].includes(style.display) &&
          !el.querySelector("input, select, textarea, button, .btn");
        if (clampable) {
          clamps.push([td, el.innerText.replace(/\n+/g, " · ").trim()]);
        } else {
          item.tall.add(row);
        }
      }
    }
  }
  for (const [td, title] of clamps) {
    td.dataset.clamp = "";
    td.title = title;
  }
  const heights = all.map(({ rows, tall }) =>
    rows.length < 2
      ? 0
      : Math.max(
          0,
          ...rows.filter((row) => !tall.has(row)).map((r) => r.offsetHeight),
        ),
  );
  all.forEach(({ table }, i) => {
    if (heights[i]) {
      table.style.setProperty("--row-height", `${heights[i]}px`);
    }
  });
  for (const [scroller, top] of scrollers) {
    if (scroller && scroller.scrollTop !== top) scroller.scrollTop = top;
  }
};
